<template>
  <div>
    <b-card
      :title="sensitivity.marketDataName"
      :sub-title="sensitivity.currency"
    >
      <b-row
        ><b-col> <Plotly :data="barData" :layout="layout"></Plotly> </b-col
      ></b-row>
      <b-row
        ><b-col>
          <b-table
            class="table-dark"
            striped
            hover
            :items="sensitivity.sensitivities"
          >
          </b-table> </b-col
      ></b-row>
    </b-card>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import { styledLayout } from "@/utils/plotlyLayout.js";
export default {
  props: {
    sensitivity: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      barData: [
        {
          x: this.sensitivity.sensitivities.map(s => s.identifier),
          y: this.sensitivity.sensitivities.map(s => s.value),
          type: "bar"
        }
      ],
      layout: styledLayout({
        title: "Sensitivity by bucket"
      })
    };
  },
  components: { Plotly }
};
</script>
